export const messages = {
  en: {
    merchantManage: {
      queryCondition: 'Query Conditions',
      inputStoreId: 'Please enter store ID',
      inputName: 'Please enter name',
      inputTel: 'Please enter phone number',
      search: 'Search',
      reset: 'Reset',
      merchantCompany: 'Merchant Company',
      document: 'Document',
      add: 'Add',
      id: 'ID',
      name: 'Name',
      address: 'Address',
      admin: 'Admin',
      tel: 'Phone',
      createTime: 'Create Time',
      operation: 'Operation',
      limitLogin: 'Restrict Login',
      recoverLogin: 'Restore Login',
      resetPwd: 'Reset Password',
      manageShop: 'Manage Shop',
      delete: 'Delete'
    }
  },
  zh: {
    merchantManage: {
      queryCondition: '查询条件',
      inputStoreId: '请输入商家编号',
      inputName: '请输入名称',
      inputTel: '请输入电话',
      search: '查询',
      reset: '重置',
      merchantCompany: '商家公司',
      document: '文档',
      add: '添加',
      id: '编号',
      name: '名称',
      address: '地址',
      admin: '管理员',
      tel: '电话',
      createTime: '创建时间',
      operation: '操作',
      limitLogin: '限制登录',
      recoverLogin: '恢复登录',
      resetPwd: '重置密码',
      manageShop: '管理店铺',
      delete: '删除'
    }
  }
}